document.addEventListener("DOMContentLoaded", () => {
  /** HTML maxlength に頼らず JS で検知する（日本語でも 15 超でエラー表示できるように） */
  const NAIRE_MAX_LEN = 15;

  /**
   * 名入れバリデーション共通処理
   */
  const validateNaireInput = (target) => {
    if (!target || target.disabled) return;

    const block = target.closest(".a_option__block");
    if (!block) return;

    const errorMsg = block.querySelector("[data-naire-error]");
    const formEl = target.closest("form") || (target.getAttribute("form") ? document.getElementById(target.getAttribute("form")) : null);
    const scope = formEl || target.closest("product-form") || document;
    const submitBtn = scope.querySelector('button[name="add"]');

    const setInvalid = () => {
      if (errorMsg) errorMsg.style.display = "block";
      target.classList.add("is-error");
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute("aria-disabled", "true");
      }
    };

    const setValid = () => {
      if (errorMsg) errorMsg.style.display = "none";
      target.classList.remove("is-error");
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.removeAttribute("aria-disabled");
      }
    };

    // 変換中（IME）は判定をスキップ
    if (target.getAttribute("data-is-composing") === "true") return;

    const val = target.value;
    if (val === "") {
      setValid();
      return;
    }

    if (val.length > NAIRE_MAX_LEN) {
      setInvalid();
      return;
    }

    // 許可：ひらがな、カタカナ、漢字、全角英字（全角スペースは \u3000、々・〆・〇は \u3005-\u3007）
    const allowedPattern = /^[\u3000\u3005-\u3007\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF\uFF21-\uFF3A\uFF41-\uFF5A]+$/;
    if (!allowedPattern.test(val)) {
      setInvalid();
      return;
    }

    setValid();
  };

  /**
   * のし選択に応じて名入れブロック表示・入力可否を同期（data-naire-allowed は熨斗マスタ metaobject）
   */
  const syncNoshiNaireFromSelect = (selectEl) => {
    if (!selectEl || !selectEl.matches("[data-noshi-naire-select]")) return;

    const wrapper =
      selectEl.closest(".a_product-option__wrapper") || selectEl.closest(".a_option__wrapper");
    let section = wrapper?.querySelector("[data-noshi-naire-section]");
    // main-product は .a_option__wrapper が二重で、名入れブロックが内側ラッパーの外＝親側にある
    if (!section && wrapper?.parentElement) {
      section = wrapper.parentElement.querySelector("[data-noshi-naire-section]");
    }
    if (!section) return;

    const opt = selectEl.selectedOptions?.[0] || selectEl.options[selectEl.selectedIndex];
    const raw = opt?.getAttribute("data-naire-allowed");
    const allowed = raw === "1" || raw === "true";

    const input = section.querySelector("[data-naire-input]");
    const formEl = selectEl.closest("form") || (selectEl.getAttribute("form") ? document.getElementById(selectEl.getAttribute("form")) : null);
    const scope = formEl || selectEl.closest("product-form") || document;
    const submitBtn = scope.querySelector('button[name="add"]');

    if (!allowed) {
      section.setAttribute("hidden", "");
      if (input) {
        input.value = "";
        input.disabled = true;
        input.classList.remove("is-error");
      }
      const err = section.querySelector("[data-naire-error]");
      if (err) err.style.display = "none";
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.removeAttribute("aria-disabled");
      }
      return;
    }

    section.removeAttribute("hidden");
    if (input) {
      input.disabled = false;
      validateNaireInput(input);
    }
  };

  const initNoshiNaireSelects = () => {
    document.querySelectorAll("select[data-noshi-naire-select]").forEach((sel) => {
      syncNoshiNaireFromSelect(sel);
    });
  };

  document.addEventListener("change", (e) => {
    const t = e.target;
    if (t?.matches?.("select[data-noshi-naire-select]")) {
      syncNoshiNaireFromSelect(t);
    }
  });

  initNoshiNaireSelects();

  // イベント設定（デリゲート方式）
  document.addEventListener("input", (event) => {
    const target = event.target;
    if (!target.hasAttribute("data-naire-input")) return;

    // 変換イベントの初期化（一度だけ）
    if (!target.dataset.eventInitialized) {
      target.addEventListener("compositionstart", () => target.setAttribute("data-is-composing", "true"));
      target.addEventListener("compositionend", (e) => {
        target.setAttribute("data-is-composing", "false");
        validateNaireInput(e.target);
      });
      target.dataset.eventInitialized = "true";
    }

    // デバウンス（0.5秒待って実行）
    clearTimeout(target.timeoutId);
    target.timeoutId = setTimeout(() => {
      validateNaireInput(target);
    }, 500);
  });
});
